export type NormalizedError = {
  message: string;
  code?: string;
  raw?: unknown;
};

export function normalizeError(err: unknown, fallback = "Unexpected error"): NormalizedError {
  if (err instanceof Error) {
    const anyErr = err as any;
    const code = typeof anyErr.code === "string" ? anyErr.code : undefined;
    return { message: err.message || fallback, code, raw: err };
  }

  if (typeof err === "string") return { message: err || fallback, raw: err };

  if (err && typeof err === "object") {
    const anyErr = err as any;

    const message =
      typeof anyErr.message === "string" ? anyErr.message :
      typeof anyErr.error_description === "string" ? anyErr.error_description :
      typeof anyErr.details === "string" ? anyErr.details :
      typeof anyErr.hint === "string" ? anyErr.hint :
      fallback;

    const code =
      typeof anyErr.code === "string" ? anyErr.code :
      typeof anyErr.status === "number" ? String(anyErr.status) :
      typeof anyErr.statusCode === "number" ? String(anyErr.statusCode) :
      undefined;

    return { message, code, raw: err };
  }

  return { message: fallback, raw: err };
}

export function errorMessage(err: unknown, fallback?: string) {
  return normalizeError(err, fallback).message;
}

export function errorCode(err: unknown) {
  return normalizeError(err).code;
}

export function toError(err: unknown, fallback = "Unexpected error"): Error {
  const n = normalizeError(err, fallback);
  const e: any = new Error(n.message || fallback);
  e.cause = n.raw;
  if (n.code) e.code = n.code;
  return e as Error;
}

/**
 * Safe text rendering helper to prevent React error #31
 * Re-exported from renderSafe.ts for convenience
 */
export { safeText } from './renderSafe';

